import defaultLogo from 'assets/defaultLogoHirenest.svg';

export const IconTest = ({ url, size, className }) => (
  <div
    style={{ height: `${size}px`, width: `${size}px` }}
    className={`flex-none rounded bg-[#F6F6F7] p-[10px] ${className}`}>
    <img src={url || defaultLogo} className="h-full w-full rounded-sm" />
  </div>
);
